import { render, staticRenderFns } from "./faceAuth.vue?vue&type=template&id=657b07ee&scoped=true&"
import script from "./faceAuth.vue?vue&type=script&lang=js&"
export * from "./faceAuth.vue?vue&type=script&lang=js&"
import style0 from "./faceAuth.vue?vue&type=style&index=0&id=657b07ee&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "657b07ee",
  null
  
)

export default component.exports